package org.teddapp.project.sync

import com.tedd.db.TeddDatabase
import org.teddapp.project.db.nowMillis
import org.teddapp.project.server.ServerSession

/**
 * Envoie tout de suite quelques lignes précises, sans attendre le prochain cycle de
 * synchronisation : une conversation doit être connue du serveur avant sa première
 * question. Les lignes déjà envoyées sont laissées ; un envoi en double est sans effet.
 */
internal suspend fun pushNow(db: TeddDatabase, session: ServerSession, rows: List<Pair<EntityKind, String>>) {
    val remote = RustRemoteStore(session, db)
    for ((entity, id) in rows) {
        val dirty = SyncEntityOps.selectDirty(entity, db).filter { it.id == id }
        if (dirty.isEmpty()) continue
        remote.push(entity, dirty)
        val at = nowMillis()
        db.transaction { for (row in dirty) SyncEntityOps.markSynced(entity, db, row.id, row.updatedAt, at) }
    }
}
